export default "__VITE_ASSET__D7pqDZem__"